import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { FormService } from '@app/services/form.service';
import { takeUntil } from 'rxjs/operators';
import { BankAccountInterface } from '@app/interfaces/bank-account.interface';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { HypoSelectComponent } from '@app/components/form-components/hypo-select/hypo-select.component';
import { HypoInputComponent } from '@app/components/form-components/hypo-input/hypo-input.component';
import { TooltipComponent } from '@app/components/tooltip/tooltip.component';

@Component({
    selector: 'app-bank-account-dialog',
    templateUrl: './bank-account-dialog.component.html',
    styleUrls: ['./bank-account-dialog.component.scss'],
    imports: [
        MatIconModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatInputModule,
        MatSlideToggleModule,
        MatButtonModule,
        HypoSelectComponent,
        HypoInputComponent,
        TooltipComponent,
    ],
})
export class BankAccountDialogComponent implements OnInit, OnDestroy {
    dialogRef = inject<MatDialogRef<BankAccountDialogComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);

    public readonly formService = inject(FormService);

    protected destroyed$: Subject<void> = new Subject<void>();

    public accountDialogForm: UntypedFormGroup;
    public bankAccounts: BankAccountInterface[];
    public account: BankAccountInterface;

    public showMore: boolean = false;

    public close(data?: any) {
        this.dialogRef.close(data);
    }

    ngOnInit() {
        this.formService.resetBankList();
        this.account = this.data?.account?.getRawValue();
        this.bankAccounts = this.data?.bankAccounts?.getRawValue();
        this.showMore = this.data?.showMore;
        this.accountDialogForm = this.formService.createBankAccountForm(this.account, this.bankAccounts, this.showMore);

        this.accountDialogForm
            .get('bankCode')
            .valueChanges.pipe(takeUntil(this.destroyed$))
            .subscribe((value) => {
                if (value) {
                    this.accountDialogForm.get('bankCodeDisplay').patchValue(value);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroyed$?.next();
        this.destroyed$?.complete();
    }

    continue() {
        if (this.formService.hasValidVisibleControls(this.accountDialogForm, true)) {
            const formData = this.accountDialogForm.getRawValue();
            this.accountDialogForm
                .get('number')
                .patchValue(
                    formData.numberBefore ? `${formData.numberBefore}-${formData.numberAfter}` : formData.numberAfter
                );
            this.close(this.accountDialogForm);
        }
    }
}
